import {createSelector} from 'reselect'
import {State} from 'lib/store'
import {NavigationState} from 'lib/navigation'

const selectNavigationFeature = (state: State): NavigationState => state.navigation

export const getHeader = createSelector(selectNavigationFeature, navigation => navigation.header)
export const getSubheader = createSelector(selectNavigationFeature, navigation => navigation.subheader)
export const getAction = createSelector(selectNavigationFeature, navigation => navigation.action)